import Vue from 'vue';
import { parse, format, parseFormatDate } from '@/helpers/dates';

Vue.filter('parseDate', (date: string, format: string = 'yyyy-MM-dd HH:mm:ss', otherwise: Date = new Date()) => {
  return date && parse(date, format, otherwise);
});

Vue.filter('formatDate', (date: Date, pattern: string = 'dd/MM/yyyy HH:mm:ss') => {
  return date && format(date, pattern);
});

Vue.filter('parseFormatDate', (date: string) => date && parseFormatDate(date));
